import ApiResourceManager from '../ApiResourceManager';

/**
 * The restaurant's Business details — its business name, confirmed on the Go Live
 * checklist, and the legal facts a hosted gateway's payouts need (the Online payment
 * step's "Business details for payouts" card, and My info for PLG restaurants).
 *
 * Company-scoped by the `x-on-behalf-of-company` header the client already sends,
 * exactly like `/business-profile`; there is no id in the path.
 */
export default class BusinessDetailsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/business-details',
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/business-details',
      data,
    });

  /** The Go Live checklist's one legal field; answers with the same record as `get`. */
  updateBusinessName = (businessName) =>
    this.request({
      method: 'PUT',
      url: '/business-name',
      data: { business_name: businessName },
    });
}
